/* Tab — size search for the header + /search predictive search (Mordy Oct 29 6:17 PM).
   Typing a pad size ("17x24", "24 x 17", "17 by 24", "17*24", 17"x24") shows the products sold in that size,
   each row linking straight to the product page with that size pre-selected.
   Also: no "View all results" middle page — Enter goes straight to the product when exactly one matches.
   Size map read from each product's own Size variants on Oct 29 2026 (theme-side only; products untouched).
   Undo: remove the tab-search-sizes.js line in layout/theme.liquid. */
(function () {
  'use strict';
  if (window.__tabSizeSearch) return;
  window.__tabSizeSearch = true;

  /* size (small x large) -> product handles, in the order they should show */
  var SIZE_MAP = {
    '17x24': ['chuckles™', 'chucks™-premium'],
    '30x34': ['cozykids™-1'],
    '23x36': ['chucks™-premium'],
    '30x36': ['chucks™-max', 'chucks™-premium'],
    '36x36': ['chucks™-max', 'chucks™-max-1', 'chucks™-premium'],
    '40x40': ['chucks™-max']
  };

  var INCH = '(?:\\s*(?:["\u201d\u201c\u2033\u2032\']{1,2}|in\\.?|inch(?:es)?))?';
  var SIZE_RE = new RegExp('(\\d{2})' + INCH + '\\s*(?:x|\u00d7|\\*|by)\\s*(\\d{2})' + INCH, 'i');

  function sizeKey(text) {
    var m = String(text || '').match(SIZE_RE);
    if (!m) return null;
    var a = parseInt(m[1], 10), b = parseInt(m[2], 10);
    var k = Math.min(a, b) + 'x' + Math.max(a, b);
    return SIZE_MAP[k] ? k : null;
  }
  function variantKey(v) {
    var opts = [v.option1, v.option2, v.option3, v.title];
    for (var i = 0; i < opts.length; i++) {
      var m = String(opts[i] || '').match(/(\d{2})\D{0,4}?[x\u00d7]\D{0,4}?(\d{2})/i);
      if (m) { var a = +m[1], b = +m[2]; return Math.min(a, b) + 'x' + Math.max(a, b); }
    }
    return null;
  }

  var cache = {};
  function loadProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }
  function money(cents) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function prettySize(k) { var p = k.split('x'); return p[0] + '\u2033 \u00d7 ' + p[1] + '\u2033'; }
  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* -> Promise<[{title,url,img,price,compare,from,packs}]> */
  function sizeMatches(key) {
    var handles = SIZE_MAP[key] || [];
    return Promise.all(handles.map(loadProduct)).then(function (list) {
      var out = [];
      list.forEach(function (p, i) {
        if (!p) return;
        var vs = (p.variants || []).filter(function (v) { return variantKey(v) === key; });
        if (!vs.length) return;
        var avail = vs.filter(function (v) { return v.available; });
        var pool = avail.length ? avail : vs;
        var best = pool.slice().sort(function (a, b) { return a.price - b.price; })[0];
        var prices = {}; pool.forEach(function (v) { prices[v.price] = 1; });
        var packs = [];
        vs.forEach(function (v) {
          [v.option1, v.option2, v.option3].forEach(function (o) {
            var s = o ? o.trim().replace(/(\d)\s*pack/i, '$1 Pack') : ''; if (s && /pack|ct|count/i.test(s) && packs.indexOf(s) < 0) packs.push(s);
          });
        });
        var img = (best.featured_image && best.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
        out.push({
          title: p.title,
          url: '/products/' + encodeURIComponent(handles[i]) + '?variant=' + best.id,
          img: img,
          price: best.price,
          compare: best.compare_at_price && best.compare_at_price > best.price ? best.compare_at_price : 0,
          from: Object.keys(prices).length > 1,
          packs: packs
        });
      });
      return out;
    });
  }

  function rowHtml(r, i, idPrefix) {
    var price = '<div class="price' + (r.compare ? ' price--on-sale' : '') + '"><div class="price__container">' +
      '<div class="price__regular"><span class="price-item price-item--regular">' + (r.from ? 'From ' : '') + money(r.price) + '</span></div>' +
      '<div class="price__sale"><span><s class="price-item price-item--regular">' + (r.compare ? money(r.compare) : '') + '</s></span>' +
      '<span class="price-item price-item--sale price-item--last">' + (r.from ? 'From ' : '') + money(r.price) + '</span></div></div></div>';
    return '<li id="' + idPrefix + (i + 1) + '" class="predictive-search__list-item tsz-row" role="option" aria-selected="false">' +
      '<a href="' + esc(r.url) + '" class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text" tabindex="-1">' +
      (r.img ? '<img class="predictive-search__image" src="' + esc(imgUrl(r.img, 150)) + '" alt="" width="50" height="50" loading="lazy">' : '') +
      '<div class="predictive-search__item-content">' +
      '<p class="predictive-search__item-heading h5">' + esc(r.title) + '</p>' +
      '<span class="tsz-size">' + esc(r.sizeLabel) + (r.packs.length ? ' \u00b7 ' + esc(r.packs.join(' / ')) : '') + '</span>' +
      price + '</div></a></li>';
  }

  function sizeResultsMarkup(key) {
    return sizeMatches(key).then(function (rows) {
      if (!rows.length) return null;
      rows.forEach(function (r) { r.sizeLabel = prettySize(key); });
      var heading = 'Size ' + prettySize(key);
      return '<div id="predictive-search-results" role="listbox">' +
        '<div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper predictive-search__results-groups-wrapper--no-suggestions tsz-results">' +
        '<div class="predictive-search__result-group"><div>' +
        '<h2 id="predictive-search-products" class="predictive-search__heading text-body caption-with-letter-spacing">' + esc(heading) + '</h2>' +
        '<ul id="predictive-search-results-products-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-products">' +
        rows.map(function (r, i) { return rowHtml(r, i, 'predictive-search-option-product-'); }).join('') +
        '</ul></div></div></div></div>' +
        '<span class="hidden" data-predictive-search-live-region-count-value>' + rows.length + (rows.length === 1 ? ' result' : ' results') + '</span>';
    });
  }

  /* ---------- Keyword synonyms (Mordy 6:32 PM): words people search with that aren't in the product titles.
     Each phrase suggests itself and brings up its products. Theme-side only (no product tags). ---------- */
  var BABY = ['chuckles™'], KIDS = ['cozykids™-1'], ADULT = ['chucks™-max', 'chucks™-max-1', 'chucks™-premium'];
  var SHARED = KIDS.concat(ADULT);
  /* [phrase shown, products, extra spellings that match it, related products shown after (Mordy 6:45 PM: "kids" also brings up baby)] */
  var KEYWORDS = [
    ['kids', KIDS, ['kid', 'children', 'child', 'kiddo'], BABY],
    ['baby', BABY, ['babies', 'babys'], KIDS],
    ['changing pad', BABY, ['changing pads', 'changeing pad', 'chaning pad', 'change pad']],
    ['changing pad liners', BABY, ['changing pad liner', 'changing liner', 'changing table liner']],
    ['changing table pad', BABY, ['changing table pads', 'changing table']],
    ['diaper changing pad', BABY, ['diaper pad', 'diaper changing', 'diaper change pad', 'diaper']],
    ['disposable changing pad', BABY, ['disposable changing pads', 'disposable changing liner']],
    ['baby changing pad', BABY, ['baby pad', 'baby pads', 'baby changing'], KIDS],
    ['infant changing pad', BABY, ['infant', 'infant pad']],
    ['newborn changing pad', BABY, ['newborn', 'new born']],
    ['nappy changing mat', BABY, ['nappy', 'nappy mat', 'changing mat']],
    ['kids bed pad', KIDS, ['kids bed pads', 'kid bed pad', 'children bed pad', 'kids pad'], BABY],
    ['bedwetting pad', KIDS, ['bed wetting pad', 'bedwetting', 'bed wetting', 'bedwetting pads', 'bed weting', 'bedweting']],
    ['toddler bed pad', KIDS, ['toddler', 'toddler pad'], BABY],
    ['potty training pad', KIDS, ['potty training', 'potty', 'potty pad']],
    ['nighttime pad', KIDS, ['night time pad', 'nighttime', 'overnight pad', 'night pad']],
    ['kids mattress protector', KIDS, ['mattress protector kids', 'kids mattress pad', 'crib mattress protector'], BABY],
    ['chux', ADULT, ['chuks', 'chux pads', 'chuks pads']],
    ['chuck pads', ADULT, ['chucks pads', 'chuck pad', 'chucks']],
    ['underpads', ADULT, ['underpad', 'under pad', 'under pads', 'underpad disposable']],
    ['incontinence pads', ADULT, ['incontinence pad', 'incontinence', 'incontinance', 'incontenence', 'inkontinence', 'adult incontinence']],
    ['disposable bed pads', ADULT, ['disposable bed pad', 'disposable underpads']],
    ['hospital bed pads', ADULT, ['hospital pad', 'hospital pads', 'hospital underpad', 'medical pad']],
    ['adult bed pads', ADULT, ['adult bed pad', 'adult pad', 'adult pads', 'adults']],
    ['elderly bed pads', ADULT, ['elderly', 'elder care', 'senior', 'seniors', 'senior bed pad']],
    ['mattress protector', ADULT, ['mattress protectors', 'mattress pad', 'mattress cover']],
    ['bed pads', SHARED, ['bed pad', 'bedpad', 'bedpads']],
    ['bed mat', SHARED, ['bed mats', 'bedmat']],
    ['pee pads', SHARED, ['pee pad', 'wee pad', 'urine pad']],
    ['waterproof bed pad', SHARED, ['waterproof pad', 'waterproof sheet', 'absorbent pad', 'leakproof pad']]
  ];
  function kwNorm(s) {
    return String(s || '').toLowerCase().replace(/[\u2122\u00ae]/g, '').replace(/[^a-z0-9]+/g, ' ').trim()
      .split(' ').map(function (w) { return (w.length > 3 && /s$/.test(w) && !/ss$/.test(w)) ? w.slice(0, -1) : w; }).join(' ');
  }
  KEYWORDS.forEach(function (k) { k.forms = [k[0]].concat(k[2] || []).map(kwNorm); });
  function kwMatches(q) {
    var nq = kwNorm(q);
    if (nq.length < 2 || /^\d/.test(nq)) return [];
    var out = [];
    KEYWORDS.forEach(function (k, idx) {
      var best = 9;
      k.forms.forEach(function (f) {
        var sc = 9;
        if (f === nq) sc = 0;
        else if (f.indexOf(nq) === 0) sc = 1;
        else if ((' ' + f).indexOf(' ' + nq) > -1) sc = 2;
        else if (f.indexOf(' ') > -1 && (' ' + nq + ' ').indexOf(' ' + f + ' ') > -1) sc = 3;
        if (sc < best) best = sc;
      });
      if (best < 9) out.push({ k: k, s: best, i: idx });
    });
    out.sort(function (a, b) { return a.s - b.s || a.k[0].length - b.k[0].length || a.i - b.i; });
    return out;
  }
  /* the keyword's own products first, then related ones (kids -> baby, baby -> kids) unless noRel */
  function kwHandles(q, noRel) {
    if (kwNorm(q).length < 2) return [];
    var seen = {}, hs = [], top = kwMatches(q).slice(0, 3);
    function add(h) { if (!seen[h]) { seen[h] = 1; hs.push(h); } }
    top.forEach(function (m) { m.k[1].forEach(add); });
    if (!noRel) top.forEach(function (m) { if (m.s <= 1 && m.k[3]) m.k[3].forEach(add); });
    return hs;
  }
  /* the suggestion line for the related audience: "kids..." suggests "baby", "baby..." suggests "kids" */
  function kwRelatedSug(q) {
    var m = kwMatches(q)[0];
    if (!m || m.s > 1 || !m.k[3]) return null;
    return m.k[3] === BABY ? 'baby' : m.k[3] === KIDS ? 'kids' : null;
  }
  function productRow(p) {
    var cmp = p.compare_at_price_min && p.compare_at_price_min > p.price_min ? p.compare_at_price_min : 0;
    return { url: '/products/' + encodeURIComponent(p.handle), title: p.title, img: p.featured_image, price: p.price_min, compare: cmp, from: !!p.price_varies, sizeLabel: '', packs: [] };
  }
  function handleOf(href) {
    try { var m = decodeURIComponent(new URL(href, location.href).pathname).match(/\/products\/([^\/?#]+)/); return m ? m[1] : null; }
    catch (e) { return null; }
  }
  /* after Shopify's rows are on screen: put the keyword's products first, adding any Shopify didn't find */
  function augment(ps, q) {
    var hs = kwHandles(q);
    if (!hs.length) return;
    Promise.all(hs.map(loadProduct)).then(function (prods) {
      if (ps.getQuery() !== q) return;
      var box = ps.querySelector('#predictive-search-results');
      if (!box) return;
      var list = box.querySelector('#predictive-search-results-products-list');
      if (!list) {
        var wrap = box.querySelector('#predictive-search-results-groups-wrapper');
        if (!wrap) { wrap = document.createElement('div'); wrap.id = 'predictive-search-results-groups-wrapper'; box.appendChild(wrap); }
        wrap.className = 'predictive-search__results-groups-wrapper predictive-search__results-groups-wrapper--no-suggestions';
        wrap.innerHTML = '<div class="predictive-search__result-group"><div>' +
          '<h2 id="predictive-search-products" class="predictive-search__heading text-body caption-with-letter-spacing">Products</h2>' +
          '<ul id="predictive-search-results-products-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-products"></ul></div></div>';
        list = wrap.querySelector('ul');
      }
      var existing = {};
      Array.prototype.forEach.call(list.children, function (li) { var a = li.querySelector('a'); var h = a && handleOf(a.getAttribute('href')); if (h) existing[h] = li; });
      var anchor = list.firstChild;
      prods.forEach(function (p, i) {
        if (!p) return;
        var li = existing[p.handle];
        if (!li) {
          var t = document.createElement('template');
          t.innerHTML = rowHtml(productRow(p), 0, 'tsk-');
          li = t.content.firstChild;
        }
        list.insertBefore(li, anchor);
        anchor = li.nextSibling;
      });
      /* an exact keyword ("changing pad", "kids", "chux"): only that keyword's products */
      var ms = kwMatches(q);
      if (ms.length && ms[0].s === 0) {
        var keep = {}; ms.filter(function (m) { return m.s === 0; }).forEach(function (m) { m.k[1].concat(m.k[3] || []).forEach(function (h) { keep[h] = 1; }); });
        Array.prototype.slice.call(list.children).forEach(function (li) { var a = li.querySelector('a'); var h = a && handleOf(a.getAttribute('href')); if (h && !keep[h]) li.remove(); });
      }
      Array.prototype.forEach.call(list.children, function (li, i) { li.id = 'predictive-search-option-product-' + (i + 1); li.setAttribute('aria-selected', 'false'); });
      var live = ps.querySelector('[data-predictive-search-live-region-count-value]');
      var n = list.children.length;
      if (live) live.textContent = n + (n === 1 ? ' result' : ' results');
    });
  }

  /* ---------- Suggestions (Mordy 6:31 PM): text suggestions above the product rows.
     Clicking one (or arrow + Enter) puts it in the search box, hides the list and refreshes the products —
     no /search page. Partial sizes ("30", "17") suggest full sizes ("30x34", "30x36"). ---------- */
  var SUG_ICON = '<svg class="tsq__icon" viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" focusable="false">' +
    '<circle cx="8.5" cy="8.5" r="5.75" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
    '<path d="M13 13l4.25 4.25" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var PARTIAL_RE = new RegExp('^\\s*(\\d{2})' + INCH + '\\s*(?:(?:x|\u00d7|\\*|by)\\s*(\\d{0,2})' + INCH + ')?\\s*$', 'i');
  function sizeSuggest(q) {
    if (sizeKey(q)) return [];
    var m = String(q || '').match(PARTIAL_RE);
    if (!m) return [];
    var a = m[1], b = m[2] || '';
    var first = [], rest = [];
    Object.keys(SIZE_MAP).forEach(function (k) {
      var p = k.split('x');
      if (p[0] === a && p[1].indexOf(b) === 0) first.push(k);
      else if (p[1] === a && p[0].indexOf(b) === 0) rest.push(k);
    });
    return first.concat(rest);
  }
  function sugHtml(items) {
    if (!items.length) return '';
    return '<div class="tsq" data-tsq-block><ul class="tsq__list list-unstyled" role="group" aria-label="Suggestions">' +
      items.map(function (it, i) {
        return '<li id="predictive-search-option-tsq-' + (i + 1) + '" class="tsq__item" role="option" aria-selected="false" data-tsq="' + esc(it.text) + '">' +
          SUG_ICON + '<span class="tsq__text">' + it.html + '</span></li>';
      }).join('') + '</ul></div>';
  }
  function boldRest(text, q) {
    var t = String(text), lq = String(q || '').trim().toLowerCase();
    if (lq && t.toLowerCase().indexOf(lq) === 0) return '<span class="tsq__typed">' + esc(t.slice(0, lq.length)) + '</span>' + esc(t.slice(lq.length));
    return esc(t);
  }
  function partialSizeMarkup(keys, q) {
    return Promise.all(keys.map(sizeMatches)).then(function (lists) {
      var byUrlBase = {}, rows = [];
      lists.forEach(function (list, i) {
        list.forEach(function (r) {
          var base = r.url.split('?')[0];
          if (byUrlBase[base]) { byUrlBase[base].sizes.push(prettySize(keys[i])); return; }
          r.sizes = [prettySize(keys[i])];
          byUrlBase[base] = r; rows.push(r);
        });
      });
      rows.forEach(function (r) { r.sizeLabel = r.sizes.join(', '); if (r.sizes.length > 1) r.packs = []; });
      var sug = sugHtml(keys.map(function (k) { return { text: k, html: boldRest(k, q.replace(/\s+/g, '')) }; }));
      return '<div id="predictive-search-results" role="listbox">' + sug +
        '<div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper predictive-search__results-groups-wrapper--no-suggestions tsz-results">' +
        '<div class="predictive-search__result-group"><div>' +
        '<h2 id="predictive-search-products" class="predictive-search__heading text-body caption-with-letter-spacing">Products</h2>' +
        '<ul id="predictive-search-results-products-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-products">' +
        rows.map(function (r, i) { return rowHtml(r, i, 'predictive-search-option-product-'); }).join('') +
        '</ul></div></div></div></div>' +
        '<span class="hidden" data-predictive-search-live-region-count-value>' + rows.length + (rows.length === 1 ? ' result' : ' results') + '</span>';
    });
  }

  function productsOnly(markup, q, showSug) {
    var t = document.createElement('template');
    t.innerHTML = markup;
    var root = t.content;
    /* text suggestions from Shopify's own query suggestions (not collections/pages), minus the exact query */
    var sugItems = [];
    if (showSug) {
      var lq = String(q || '').trim().toLowerCase();
      var seenSug = {};
      seenSug[kwNorm(q)] = 1;
      var rel = kwRelatedSug(q);
      if (rel && seenSug[kwNorm(rel)]) rel = null;
      var kwCap = rel ? 3 : 4;
      kwMatches(q).forEach(function (m) {
        var nk = kwNorm(m.k[0]);
        if (seenSug[nk] || sugItems.length >= kwCap || (rel && nk === kwNorm(rel))) return;
        seenSug[nk] = 1;
        sugItems.push({ text: m.k[0], html: boldRest(m.k[0], q) });
      });
      if (rel) { seenSug[kwNorm(rel)] = 1; sugItems.push({ text: rel, html: boldRest(rel, q) }); }
      root.querySelectorAll('#predictive-search-results-queries-list .predictive-search__item-query-result').forEach(function (p) {
        var text = (p.getAttribute('aria-label') || p.textContent || '').trim();
        if (!text || text.toLowerCase() === lq || seenSug[kwNorm(text)] || sugItems.length >= 6) return;
        seenSug[kwNorm(text)] = 1;
        sugItems.push({ text: text, html: boldRest(text, q) });
      });
    }
    root.querySelectorAll('.predictive-search__result-group > div').forEach(function (d) {
      if (!d.querySelector('#predictive-search-results-products-list')) d.remove();
    });
    root.querySelectorAll('.predictive-search__result-group').forEach(function (g) { if (!g.children.length) g.remove(); });
    var n = root.querySelectorAll('#predictive-search-results-products-list li').length;
    if (!n) {
      var wrap = root.querySelector('#predictive-search-results-groups-wrapper');
      var p = document.createElement('p');
      p.className = 'tsz-empty';
      p.textContent = 'No products found for \u201c' + q + '\u201d';
      if (wrap) { wrap.innerHTML = ''; wrap.appendChild(p); }
      else {
        var host = root.querySelector('#predictive-search-results') || root;
        var w = document.createElement('div');
        w.id = 'predictive-search-results-groups-wrapper';
        w.className = 'predictive-search__results-groups-wrapper';
        w.appendChild(p);
        host.insertBefore(w, host.firstChild);
      }
    }
    /* "$29.95 USD" -> "$29.95", same as the size rows */
    root.querySelectorAll('.price-item').forEach(function (el) {
      el.childNodes.forEach(function (nd) { if (nd.nodeType === 3) nd.nodeValue = nd.nodeValue.replace(/\s*USD\s*$/, ' '); });
    });
    var live = root.querySelector('[data-predictive-search-live-region-count-value]');
    if (live) live.textContent = n + (n === 1 ? ' result' : ' results');
    if (sugItems.length) {
      var holder = root.querySelector('#predictive-search-results') || root;
      var st = document.createElement('template');
      st.innerHTML = sugHtml(sugItems);
      holder.insertBefore(st.content, holder.firstChild);
    }
    var div = document.createElement('div');
    div.appendChild(root.cloneNode(true));
    return div.innerHTML;
  }

  /* ---------- 1) predictive search: size queries render our rows ---------- */
  function patchPredictive() {
    var C = customElements.get('predictive-search');
    if (!C || C.prototype.__tszPatched) return;
    var P = C.prototype;
    P.__tszPatched = true;

    /* Only product rows (Mordy 6:18 PM): drop Suggestions / collections / pages; friendly line when nothing matches */
    var origRender = P.renderSearchResults;
    P.renderSearchResults = function (markup) {
      var q = this.getQuery();
      try { markup = productsOnly(markup, q, q.toLowerCase() !== this.__tsqPicked); } catch (e) {}
      var res = origRender.call(this, markup);
      try { if (!sizeKey(q)) augment(this, q); } catch (e) {}
      return res;
    };
    var orig = P.getSearchResults;
    P.getSearchResults = function (term) {
      var key = sizeKey(term);
      var self = this;
      if (!key) {
        var keys = term.toLowerCase() === this.__tsqPicked ? [] : sizeSuggest(term);
        if (!keys.length) return orig.call(this, term);
        var pKey = 'tszp:' + term.replace(/\s+/g, '-').toLowerCase();
        this.setLiveRegionLoadingState();
        if (this.cachedResults[pKey]) { origRender.call(this, this.cachedResults[pKey]); return; }
        partialSizeMarkup(keys, term).then(function (markup) {
          if (self.getQuery() !== term) return;
          self.cachedResults[pKey] = markup;
          origRender.call(self, markup);
        }).catch(function () { orig.call(self, term); });
        return;
      }
      var qKey = 'tsz:' + term.replace(' ', '-').toLowerCase();
      this.setLiveRegionLoadingState();
      if (this.cachedResults[qKey]) { this.renderSearchResults(this.cachedResults[qKey]); return; }
      sizeResultsMarkup(key).then(function (markup) {
        if (self.getQuery() !== term) return; /* user kept typing */
        if (!markup) return orig.call(self, term);
        self.cachedResults[qKey] = markup;
        self.renderSearchResults(markup);
      }).catch(function () { orig.call(self, term); });
    };
    var origSelect = P.selectOption;
    P.selectOption = function () {
      var li = this.querySelector('.tsq__item[aria-selected="true"]');
      if (li) return applySuggestion(this, li.getAttribute('data-tsq'));
      return origSelect.apply(this, arguments);
    };
  }

  function applySuggestion(ps, text) {
    if (!ps || !text) return;
    var input = ps.input || ps.querySelector('input[type="search"]');
    if (!input) return;
    ps.__tsqPicked = text.trim().toLowerCase();
    var block = ps.querySelector('[data-tsq-block]');
    if (block) block.remove();
    input.setAttribute('aria-activedescendant', '');
    input.value = text;
    try { input.focus({ preventScroll: true }); input.setSelectionRange(text.length, text.length); } catch (e) {}
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
  /* mouse / tap on a suggestion: keep focus in the box, then fill it */
  document.addEventListener('mousedown', function (e) {
    if (e.target.closest && e.target.closest('.tsq__item')) e.preventDefault();
  }, true);
  document.addEventListener('click', function (e) {
    var li = e.target.closest && e.target.closest('.tsq__item');
    if (!li) return;
    e.preventDefault(); e.stopPropagation();
    applySuggestion(li.closest('predictive-search'), li.getAttribute('data-tsq'));
  }, true);

  if (window.customElements) {
    customElements.whenDefined('predictive-search').then(patchPredictive);
  }

  /* ---------- 2) Enter: straight to the product when exactly one matches ---------- */
  function go(url) { window.location.href = url; }
  function norm(s) { return String(s || '').toLowerCase().replace(/[\u2122\u00ae]/g, '').replace(/[^a-z0-9+]+/g, ' ').trim(); }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.__tszPass) return;
    var action = form.getAttribute('action') || '';
    if (!/\/search\/?$/.test(action.split('?')[0])) return;
    var input = form.querySelector('input[name="q"]');
    var q = input ? input.value.trim() : '';
    if (!q) return;
    var ps = form.closest('predictive-search');
    var sugLi = ps && ps.querySelector('.tsq__item[aria-selected="true"]');
    if (sugLi) { e.preventDefault(); e.stopPropagation(); applySuggestion(ps, sugLi.getAttribute('data-tsq')); return; }
    if (ps && ps.querySelector('[aria-selected="true"] a')) return; /* a highlighted row: theme opens it */
    e.preventDefault();
    var done = false;
    function fallback() { if (done) return; done = true; form.__tszPass = true; form.submit(); }
    var timer = setTimeout(fallback, 3000);
    var key = sizeKey(q);
    var p = key
      ? sizeMatches(key).then(function (rows) { return rows.map(function (r) { return r.url; }); })
      : fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var prods = (j.resources && j.resources.results && j.resources.results.products) || [];
            if (!prods.length) { var kh = kwHandles(q, true); if (kh.length) return kh.map(function (h) { return '/products/' + encodeURIComponent(h); }); }
            if (prods.length <= 1) return prods.map(function (x) { return x.url; });
            /* Shopify's search is fuzzy ("chuckles" also returns the Chucks): if the words typed name exactly one product, go there */
            var nq = norm(q);
            var exact = prods.filter(function (x) { return norm(x.title) === nq; });
            if (exact.length === 1) return [exact[0].url];
            var named = prods.filter(function (x) { return (' ' + norm(x.title) + ' ').indexOf(' ' + nq + ' ') > -1; });
            if (named.length === 1) return [named[0].url];
            return prods.map(function (x) { return x.url; });
          });
    p.then(function (urls) {
      if (done) return;
      if (urls.length === 1) { done = true; clearTimeout(timer); go(urls[0]); }
      else { clearTimeout(timer); fallback(); }
    }).catch(function () { clearTimeout(timer); fallback(); });
  }, true);

  /* ---------- 3) /search page: a size query shows the products in that size ---------- */
  function renderSearchPage() {
    if (!/^\/search\/?$/.test(location.pathname)) return;
    var q = new URLSearchParams(location.search).get('q') || '';
    var key = sizeKey(q);
    if (!key) { renderKeywordPage(q); return; }
    sizeMatches(key).then(function (rows) {
      if (!rows.length) return;
      rows.forEach(function (r) { r.sizeLabel = prettySize(key); });
      var grid = document.getElementById('ProductGridContainer');
      var host = grid || document.querySelector('.template-search');
      if (!host) return;
      var box = document.createElement('div');
      box.className = 'tsz-page page-width';
      box.innerHTML = '<div class="tsz-page__card predictive-search">' +
        '<h2 class="predictive-search__heading text-body caption-with-letter-spacing">' + esc('Size ' + prettySize(key)) + '</h2>' +
        '<ul class="predictive-search__results-list list-unstyled">' +
        rows.map(function (r, i) { return rowHtml(r, i, 'tsz-page-option-'); }).join('') + '</ul></div>';
      document.documentElement.classList.add('tsz-size-search');
      if (grid) { grid.innerHTML = ''; grid.appendChild(box); }
      else host.appendChild(box);
      var count = document.querySelector('.product-count__text, #ProductCount, #ProductCountDesktop');
      if (count) count.textContent = rows.length + (rows.length === 1 ? ' result' : ' results');
    });
  }
  /* /search for a keyword Shopify finds nothing for ("bedwetting", "chux"): show the keyword's products */
  function renderKeywordPage(q) {
    var hs = kwHandles(q);
    if (!hs.length) return;
    var grid = document.getElementById('ProductGridContainer');
    if (grid && grid.querySelector('.grid__item, .card-wrapper')) return;
    Promise.all(hs.map(loadProduct)).then(function (prods) {
      var rows = prods.filter(Boolean).map(productRow);
      if (!rows.length) return;
      var host = grid || document.querySelector('.template-search');
      if (!host) return;
      var box = document.createElement('div');
      box.className = 'tsz-page page-width';
      box.innerHTML = '<div class="tsz-page__card predictive-search">' +
        '<h2 class="predictive-search__heading text-body caption-with-letter-spacing">Products</h2>' +
        '<ul class="predictive-search__results-list list-unstyled">' +
        rows.map(function (r, i) { return rowHtml(r, i, 'tsz-page-option-'); }).join('') + '</ul></div>';
      document.documentElement.classList.add('tsz-size-search');
      if (grid) { grid.innerHTML = ''; grid.appendChild(box); }
      else host.appendChild(box);
      var count = document.querySelector('.product-count__text, #ProductCount, #ProductCountDesktop');
      if (count) count.textContent = rows.length + (rows.length === 1 ? ' result' : ' results');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderSearchPage);
  else renderSearchPage();
})();
